export default "/images/trash.svg?d55ba7a6c87c02d88d37de2110530e0e";